<form [formGroup]="form" nz-form nzLayout="vertical">

	<!-- ─── Top-level ──────────────────────────────────────────────────────── -->
	<div nz-row [nzGutter]="16">
		<div nz-col [nzSpan]="12">
			<nz-form-item>
				<nz-form-label nzRequired>Offer Name</nz-form-label>
				<nz-form-control nzErrorTip="Please enter an offer name">
					<input nz-input formControlName="name" placeholder="e.g. Standard Cover" />
				</nz-form-control>
			</nz-form-item>
		</div>
		<div nz-col [nzSpan]="12">
			<nz-form-item>
				<nz-form-label>Description</nz-form-label>
				<nz-form-control>
					<input nz-input formControlName="description" placeholder="Optional description" />
				</nz-form-control>
			</nz-form-item>
		</div>
	</div>

	<!-- ─── Sub-sections ───────────────────────────────────────────────────── -->
	<nz-tabset nzSize="small">

		<!-- ─── Rules ────────────────────────────────────────────────────────── -->
		<nz-tab nzTitle="Rules">
			<button nz-button nzType="dashed" nzSize="small" class="mb-2" (click)="addRule()">+ Add Rule</button>
			<nz-table [nzData]="[0]" nzSize="small" nzShowPagination="false" nzFrontPagination="false">
				<thead>
					<tr>
						<th>Rule Type</th>
						<th>Applied To</th>
						<th>Threshold</th>
						<th nzWidth="60px"></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let ctrl of rulesArray.controls; let i = index" [formGroup]="asGroup(ctrl)">
						<td>
							<nz-select formControlName="ruleType" style="width:100%">
								<nz-option *ngFor="let item of availableRuleTypes" [nzValue]="item" [nzLabel]="item"></nz-option>
							</nz-select>
						</td>
						<td>
							<nz-select formControlName="appliedTo" style="width:100%">
								<nz-option *ngFor="let item of availableAppliedToFoRules" [nzValue]="item" [nzLabel]="item"></nz-option>
							</nz-select>
						</td>
						<td>
							<nz-input-number formControlName="threshold" [nzMin]="0" [nzStep]="1" style="width:100%"></nz-input-number>
						</td>
						<td>
							<button nz-button nzType="text" nzDanger nzSize="small" (click)="removeRule(i)">
								<span nz-icon nzType="delete"></span>
							</button>
						</td>
					</tr>
				</tbody>
			</nz-table>
			<nz-alert *ngIf="rulesArray.length === 0" nzType="info" nzMessage="No rules defined." class="mt-2"></nz-alert>
		</nz-tab>

		<!-- ─── Lines ────────────────────────────────────────────────────────── -->
		<nz-tab nzTitle="Lines">
			<button nz-button nzType="dashed" nzSize="small" class="mb-2" (click)="addLine()">+ Add Line</button>
			<nz-table [nzData]="[0]" nzSize="small" nzShowPagination="false" nzFrontPagination="false">
				<thead>
					<tr>
						<th nzWidth="40px"></th>
						<th>Name</th>
						<th>Description</th>
						<th nzWidth="100px">Compulsory</th>
						<th nzWidth="60px"></th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let ctrl of linesArray.controls; let i = index">
						<!-- Line row -->
						<tr [formGroup]="asGroup(ctrl)">
							<td [nzExpand]="lineExpanded[i]" (nzExpandChange)="lineExpanded[i] = $event"></td>
							<td>
								<nz-select formControlName="name" style="width:100%">
									<nz-option *ngFor="let item of availableOfferLineNames" [nzValue]="item" [nzLabel]="item"></nz-option>
								</nz-select>
							</td>
							<td><input nz-input formControlName="description" placeholder="Description" /></td>
							<td><label nz-checkbox formControlName="compulsory"></label></td>
							<td>
								<button nz-button nzType="text" nzDanger nzSize="small" (click)="removeLine(i)">
									<span nz-icon nzType="delete"></span>
								</button>
							</td>
						</tr>
						<!-- Line details sub-row -->
						<tr [nzExpand]="lineExpanded[i]">
							<td colspan="5" style="padding: 0 16px 16px 40px; background: #fafafa;">
								<div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:8px;">
									<strong>Rate Details</strong>
									<button nz-button nzType="dashed" nzSize="small" (click)="addLineDetail(i)">+ Add Detail</button>
								</div>
								<nz-table
									[nzData]="[0]"
									nzSize="small"
									nzShowPagination="false"
									nzFrontPagination="false"
									[nzBordered]="true">
									<thead>
										<tr>
											<th nzWidth="40px"></th>
											<th>From Date</th>
											<th>To Date</th>
											<th>Premium Type</th>
											<th>Premium % of</th>
											<th>Premium</th>
											<th>Benefit Type</th>
											<th>Benefit % of</th>
											<th *ngIf="productType != 'Funeral'">Benefit</th>
											<th *ngIf="productType == 'Funeral'">Benefit Natural</th>
											<th *ngIf="productType == 'Funeral'">Benefit Accidental</th>
											<th *ngIf="productType == 'Funeral'">Benefit Suicide</th>
											<th>New Policies Only</th>
											<th nzWidth="60px"></th>
										</tr>
									</thead>
									<tbody>
										<ng-container *ngFor="let dCtrl of getLineDetails(i).controls; let j = index">
											<!-- Detail row -->
											<tr [formGroup]="asGroup(dCtrl)">
												<td [nzExpand]="lineDetailExpanded[i][j]" (nzExpandChange)="lineDetailExpanded[i][j] = $event"></td>
												<td>
													<nz-date-picker formControlName="fromDate" nzFormat="yyyy-MM-dd" style="width:100%"></nz-date-picker>
												</td>
												<td>
													<nz-date-picker formControlName="toDate" nzFormat="yyyy-MM-dd" style="width:100%"></nz-date-picker>
												</td>
												<td>
													<nz-select formControlName="premiumType" style="width:100%">
														<nz-option *ngFor="let item of availablePremiumTypes" [nzValue]="item" [nzLabel]="item"></nz-option>
													</nz-select>
												</td>
												<td>
													<input nz-input formControlName="premiumPercentageProperty" placeholder="Premium Percentage of Property" *ngIf="getPremiumType(i,j) == 'Percentage'">
												</td>
												<td>
													<nz-input-number formControlName="premiumAmount" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="3" style="width:100%"></nz-input-number>
												</td>
												<td>
													<nz-select formControlName="benefitType" style="width:100%">
														<nz-option *ngFor="let item of availableBenefitCalcTypes" [nzValue]="item" [nzLabel]="item"></nz-option>
													</nz-select>
												</td>
												<td>
													<input nz-input formControlName="benefitPercentageProperty" placeholder="Benefit Percentage of Property" *ngIf="getBenefitType(i,j) == 'Percentage'"/>
												</td>

												<td *ngIf="productType != 'Funeral'">
													<nz-input-number formControlName="benefitAmount" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="3" style="width:100%"></nz-input-number>
												</td>
												<td *ngIf="productType == 'Funeral'">
													<nz-form-control nzErrorTip="Please enter a value">
														<nz-input-number formControlName="benefitAmountNatural" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="3" style="width:100%"></nz-input-number>
													</nz-form-control>
												</td>
												<td *ngIf="productType == 'Funeral'">
													<nz-form-control nzErrorTip="Please enter a value">
														<nz-input-number formControlName="benefitAmountAccidental" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="3" style="width:100%"></nz-input-number>
													</nz-form-control>
												</td>
												<td *ngIf="productType == 'Funeral'">
													<nz-form-control nzErrorTip="Please enter a value">
														<nz-input-number formControlName="benefitAmountSuicide" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="3" style="width:100%"></nz-input-number>
													</nz-form-control>
												</td>

												<td style="text-align:center">
													<label nz-checkbox formControlName="appliesOnlyToNewPolicies"></label>
												</td>
												<td>
													<button nz-button nzType="text" nzDanger nzSize="small" (click)="removeLineDetail(i, j)">
														<span nz-icon nzType="delete"></span>
													</button>
												</td>
											</tr>
											<!-- Commissions sub-row for this detail -->
											<tr [nzExpand]="lineDetailExpanded[i][j]">
												<td colspan="9" style="padding: 0 16px 16px 40px; background: #f0f0f0;">
													<div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:8px;">
														<strong>Fees </strong>
														<button nz-button nzType="dashed" nzSize="small" (click)="addCommission(i, j)">+ Add Fee</button>
													</div>
													<nz-table
														[nzData]="[0]"
														nzSize="small"
														nzShowPagination="false"
														nzFrontPagination="false"
														[nzBordered]="true">
														<thead>
															<tr>
																<th>Recipient</th>
																<th nzWidth="170px">Type</th>
																<th nzWidth="100px">Amount</th>
																<th nzWidth="60px"></th>
															</tr>
														</thead>
														<tbody>
															<tr *ngFor="let cCtrl of getDetailCommissions(i, j).controls; let k = index" [formGroup]="asGroup(cCtrl)">
																<td>
																	<nz-select
																	 	nzShowSearch
																		nzAllowClear
																		formControlName="recipient"
																		style="width:100%"
																		nzPlaceHolder="Select recipient"
																		[nzLoading]="recipientsLoading"
																		[compareWith]="compareById">
																		<nz-option
																			*ngFor="let r of commissionRecipients"
																			[nzValue]="r"
																			[nzLabel]="r.name + ' (' + r.typeLabel + ')'">
																		</nz-option>
																	</nz-select>
																</td>
																<td>
																	<nz-select formControlName="commissionType">
																		<nz-option *ngFor="let item of availableCommissionTypes" [nzValue]="item" [nzLabel]="item"></nz-option>
																	</nz-select>
																</td>
																<td>
																	<nz-input-number formControlName="commissionAmount" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="3" style="width:100%"></nz-input-number>
																</td>
																<td>
																	<button nz-button nzType="text" nzDanger nzSize="small" (click)="removeCommission(i, j, k)">
																		<span nz-icon nzType="delete"></span>
																	</button>
																</td>
															</tr>
															<tr *ngIf="getDetailCommissions(i, j).length === 0">
																<td colspan="4" style="text-align:center; color:#999;">No commissions — click '+ Add Commission'</td>
															</tr>
														</tbody>
													</nz-table>
												</td>
											</tr>
										</ng-container>
										<tr *ngIf="getLineDetails(i).length === 0">
											<td *ngIf="productType != 'Funeral'" colspan="11" style="text-align:center; color:#999;">No details — click '+ Add Detail'</td>
											<td *ngIf="productType == 'Funeral'" colspan="13" style="text-align:center; color:#999;">No details — click '+ Add Detail'</td>
										</tr>
									</tbody>
								</nz-table>
							</td>
						</tr>
					</ng-container>
				</tbody>
			</nz-table>
			<nz-alert *ngIf="linesArray.length === 0" nzType="info" nzMessage="No lines defined." class="mt-2"></nz-alert>
		</nz-tab>

		<!-- ─── Benefit Splits ────────────────────────────────────────────────── -->
		<nz-tab nzTitle="Benefit Splits" *ngIf="productType == 'Funeral'">
			<button nz-button nzType="dashed" nzSize="small" class="mb-2" (click)="addBenefitSplit()">+ Add Split</button>
			<nz-table [nzData]="[0]" nzSize="small" nzShowPagination="false" nzFrontPagination="false">
				<thead>
					<tr>
						<th>Applied To</th>
						<th>Age From</th>
						<th>Age To</th>
						<th>Benefit Amount (R)</th>
						<th nzWidth="60px"></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let ctrl of benefitSplitsArray.controls; let i = index" [formGroup]="asGroup(ctrl)">
						<td>
							<nz-select formControlName="appliedTo" style="width:100%">
								<ng-container *ngFor="let item of availableAppliedToForBenefitSplits">
									<nz-option *ngIf="item == 'ChildStillBorn'" [nzValue]="item" [nzLabel]="item + '(Age in Weeks)'"></nz-option>
									<nz-option *ngIf="item != 'ChildStillBorn'" [nzValue]="item" [nzLabel]="item"></nz-option>
								</ng-container>
							</nz-select>
						</td>
						<td>
							<nz-input-number formControlName="fromAge" [nzMin]="0" [nzStep]="1" style="width:100%"></nz-input-number>
						</td>
						<td>
							<nz-input-number formControlName="toAge" [nzMin]="0" [nzStep]="1" style="width:100%"></nz-input-number>
						</td>
						<td>
							<nz-input-number formControlName="benefitAmount" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="3" style="width:100%"></nz-input-number>
						</td>
						<td>
							<button nz-button nzType="text" nzDanger nzSize="small" (click)="removeBenefitSplit(i)">
								<span nz-icon nzType="delete"></span>
							</button>
						</td>
					</tr>
				</tbody>
			</nz-table>
			<nz-alert *ngIf="benefitSplitsArray.length === 0" nzType="info" nzMessage="No benefit splits defined." class="mt-2"></nz-alert>
		</nz-tab>

		<!-- ─── Benefit Rules ────────────────────────────────────────────────── -->
		<nz-tab nzTitle="Benefit Rule" *ngIf="productType == 'TemporaryDisability' || productType == 'PermanentHealthInsurance'">
			<button nz-button nzType="dashed" nzSize="small" class="mb-2" (click)="addBenefitRule()">+ Add Rule</button>
			<nz-table [nzData]="[0]" nzSize="small" nzShowPagination="false" nzFrontPagination="false">
				<thead>
					<tr>
						<th>From {{getRulePeriodLabelSuffix()}}</th>
						<th>To {{getRulePeriodLabelSuffix()}}</th>
						<th>Recipient Type</th>
						<th>Recipient</th>
						<th>Calculation Type</th>
						<th>Amount/Percentage of benefit</th>
						<th nzWidth="60px"></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let ctrl of benefitRuleArray.controls; let i = index" [formGroup]="asGroup(ctrl)">
						<td><nz-input-number formControlName="from" [nzMin]="0" [nzStep]="1" style="width:100%"></nz-input-number></td>
						<td><nz-input-number formControlName="to" [nzMin]="0" [nzStep]="1" style="width:100%"></nz-input-number></td>
						<td>
							<nz-select formControlName="recipientType" style="width:100%" [compareWith]="compareByType"  >
								<nz-option [nzValue]="'Member'" nzLabel="Main Member"></nz-option>
								<nz-option [nzValue]="'InsuranceUnderwriter'" nzLabel="Underwriter"/>
								<nz-option [nzValue]="'InsuranceBinder'" nzLabel="Binder"/>
								<nz-option [nzValue]="'InsuranceServiceProvider'" nzLabel="Service Provider"/>
								<nz-option [nzValue]="'InsurancePolicyGroup'" nzLabel="Policy Group"/>
								<nz-option [nzValue]="'InsuranceIntermediaryAdministrator'" nzLabel="Intermediary Administrator"/>
								<nz-option [nzValue]="'InsuranceIntermediaryGroup'" nzLabel="Intermediary Group"/>
							</nz-select>
						</td>
						<td>
							<nz-select *ngIf="getRecipientType(ctrl) != 'Member'" nzShowSearch formControlName="recipient" [compareWith]="compareById"  style="width:100%">
								<ng-container *ngFor="let item of allRecipients">
									<nz-option *ngIf="item.type == getRecipientType(ctrl)" [nzValue]="item" nzLabel="{{item.name}} ({{item.typeLabel}})"></nz-option>
								</ng-container>
							</nz-select>
						</td>
						<td>
							<nz-select formControlName="calculationType" style="width:100%">
								<nz-option *ngFor="let item of availableBenefitCalcTypes" [nzValue]="item" [nzLabel]="item"></nz-option>
							</nz-select>
						</td>
						<td><nz-input-number formControlName="amount" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="3" style="width:100%"></nz-input-number></td>
						<td>
							<button nz-button nzType="text" nzDanger nzSize="small" (click)="removeBenefitRule(i)">
								<span nz-icon nzType="delete"></span>
							</button>
						</td>
					</tr>
				</tbody>
			</nz-table>
			<nz-alert *ngIf="benefitRuleArray.length === 0" nzType="info" nzMessage="No benefit percentage defined." class="mt-2"></nz-alert>
		</nz-tab>

	</nz-tabset>

</form>

<div *nzModalFooter>
	<button nz-button nzType="default" (click)="onCancel()">Cancel</button>
	<button nz-button nzType="primary" [disabled]="form.invalid" (click)="onSave()">Save</button>
</div>

<!-- [{{getAllErrors(form)|json}}] -->
